<template>
  <BasicWrapper white>
    <h2 class="text-center textHeadline2 mb-5">
      {{ $t("terms.of.use.title") }}
    </h2>
    <div class="textBody1" v-html="$t('terms.of.use.text')"></div>
  </BasicWrapper>
</template>

<script>
import BasicWrapper from "../../components/v2/layout/pageWrapper/BasicWrapper.vue";

export default {
  name: "TermsOfServiceFallbackPage",
  components: { BasicWrapper },
};
</script>
